import React from 'react';
import './App.css';
import PublicRoute from './layout/publicRoute';
import PrivateRoute from './layout/privateRoute';
import { PrivateRoutes, PublicRoutes } from './layout/routes';
import { Route, Routes } from 'react-router-dom';
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { ToastContainer } from 'react-toastify';
import LoaderComponent from './components/loder';

i18n
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'English',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      English: {
        translation: {}, // Initialize with an empty object
      },
      Arabic: {
        translation: {}, // Initialize with an empty object
      },
    },
  });

const App = () => {

  const getPrivateRoutes = () => {
    return PrivateRoutes.map((prop: any, key: number) => {
      let Component = prop.component;
      return <Route path={prop.path} element={<Component />} key={key} />;
    });
  };
  const getRoutes = () => {
    return PublicRoutes.map((prop: any, key: number) => {
      let Component = prop.component;
      return <Route path={prop.path} element={<Component />} key={key} />;
    });
  };
  return (
     <div className='my_app_container'>
      <Routes>
        <Route element={<PublicRoute />}>{getRoutes()}</Route>
        <Route element={<PrivateRoute />}>{getPrivateRoutes()}</Route>
      </Routes>
      <ToastContainer />
      <LoaderComponent />
    </div>
   
  );
}

export default App;
